import { forwardRef } from "react";
import { SnackbarContent, CustomContentProps } from "notistack";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import styled from '@emotion/styled';

const ReleaseNotesSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  ({ id, ...props }, ref) => {
    return (
      <Container ref={ref}>
        <SnackbarContentCard>
          <SnackbarCardActions>
            {props.message}
          </SnackbarCardActions>
        </SnackbarContentCard>
      </Container>
    );
  }
);

const Container = styled(SnackbarContent)`
  & > .MuiPaper-root {
    border-radius: ${props => props.theme.shape.borderRadius * 0.6}px;
  }
`;

const SnackbarContentCard = styled(Card)`
  background-color: ${(props) => {
    if (props.theme.palette.mode === 'light') {
      return props.theme.palette.background.paper;
    }

    // Offset value to make it slightly different and pop out, got the value from the figma spec by subtracting it to our paper background hex value
    const value = parseInt(props.theme.palette.background.paper.substring(1, props.theme.palette.background.paper.length), 16) + 1381657;
    return `#${value.toString(16)}`;
  }};
`;

const SnackbarCardActions = styled(CardActions)`
  min-height: 100px;
  padding-left: ${props => props.theme.spacing(2.25)};
`;

ReleaseNotesSnackbar.displayName = "ReleaseNotes";

export default ReleaseNotesSnackbar;